import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { AnyIfEmpty } from "react-redux";

export interface IDroitState {
  droits: IDroit[];
  droitsBySuousModule: IDroit[];
  objDroit: IDroit;
  openDialogDroit: boolean,
  valueEdit: string;
  descriptionEdit: string;
  filterdroits: IDroit[];
}

export interface IDroit {
  idDroit: string;
  libDroit: string;
  idSousModuleDroit: string;
  descriptionDroit: string;
  createdAt: string;
  updatedAt: string;
}



export const droitSlice: any = createSlice({
  name: "droits",
  initialState: {
    openDialogDroit: false,
    droits: [],
    objDroit: {},
    valueEdit: "",
    descriptionEdit: "",
    filterdroits: [],
    droitsBySuousModule: []
  },
  reducers: {

    addDroits: (state, action) => {
      const newDroit: any = [...state.droits, action.payload]
      state.droits = newDroit;
    },

    setValueEdit: (state, action) => {
      state.valueEdit = action.payload;
    },
    setDescriptionEdit: (state, action) => {
      state.descriptionEdit = action.payload;
    },

    setDroits: (state, action) => {
      state.droits = action.payload;
    },

    setFilterDroits: (state, action) => {
      state.filterdroits = action.payload;
    },

    setObjDroit: (state, action) => {
      state.objDroit = action.payload;
    },



    setOpenDialogDroit: (state, action) => {
      state.openDialogDroit = action.payload;
    },
    
    setDroitsBySuousModule: (state, action) => {
      state.droitsBySuousModule = action.payload;
    },

    deleteDroit: (state, action) => {
      state.droits = state.droits.filter((f: IDroit) => f.idDroit !== action.payload);
    },

    editDroit: (state, action) => {
      const newArray: any = state.droits.map((f: IDroit) => (f.idDroit === action.payload.idDroit ? action.payload : f))
      state.droits = newArray;
    },
  }
});

export const {
  setOpenDialogDroit,
  addDroits,
  setDroits,
  setObjDroit,
  deleteDroit,
  editDroit,
  setValueEdit,
  setDescriptionEdit,
  setFilterDroits,
  setDroitsBySuousModule
} = droitSlice.actions;


export default droitSlice.reducer;
